<script setup>
import { inject, ref, computed } from 'vue'
import { useVModel } from '#/general/useVModel'
import AppField from '#/general/AppField'
const { components, application, screen, global } = inject('Shared')
const props = defineProps([
  'value',
  'placeholder',
  'getError',
  'color',
  'size',
  'separatorColor',
  'hideSeparator',
  'name',
  'height',
  'background',
  'inputPadding',
  'errors',
  'disableLabel'
])
const emit = defineEmits(['update:value', 'clicked', 'input', 'focus', 'click'])
const value = useVModel(props, 'value')

function input (event) {
  emit('input', event)
  emit('update:value', event.target.value)
}

const errorMessage = computed(() => {
  if (props.errors) {
    const keys = Object.keys(props.errors)
    if (keys && keys.length > 0) {
      return props.errors[keys[0]]
    }
  }
  return null
})
</script>

<template lang="pug">
app-field(:error-message="errorMessage" :separator-color="separatorColor" :hide-separator="hideSeparator")
  .input--container
    slot(name="prepend")
    .input--wrapper
      input.appInput(
        :value='value'
        @input="input"
        :placeholder='placeholder'
        :autocomplete="name"
        :name="name"
        @click="$emit('click')"
        @focus="$emit('focus')"
        :class="`${value && value.length > 0 && !disableLabel ? 'app-input--placeholder-margin' : ''}`"
      )
      .input--placeholder(v-if="value && value.length > 0 && !disableLabel") {{ placeholder }}
    slot(name="append")
</template>
<style scoped lang="sass">
::placeholder
  color: v-bind('color') !important
.input
  outline: none !important
.errorMessage
  padding: 3px 0
  font-size: 12px
  color: #c10015
  width: 100%
  position: absolute
  bottom: -5px
  left: 0px
.input--container
  display: flex
  flex-direction: row
  align-items: center
  justify-content: space-between
  position: relative
  background: v-bind(background)
  padding: v-bind(inputPadding)
  height: v-bind('height')
  border-radius: 6px
  .input--wrapper
    position: relative
    width: 100%
    height: 100%
    .app-input--placeholder-margin
      margin-top: 3px
    .input--placeholder
      color: v-bind('color')
      border: none !important
      font-size: v-bind('placeholderSize')
      position: absolute
      top: -5px
      left: 0px
      z-index: 1
    .appInput
      width: 100%
      height: 100%
      box-sizing: border-box
      font-style: normal
      font-weight: 400
      line-height: 130%
      color: v-bind('color')
      border: none !important
      font-size: v-bind('size')
      background: v-bind(background)
      @media screen and (min-width: 1024px)
        font-weight: v-bind('components.searchBox.input.fontWeight')
        border-bottom: 0.5px solid #B4BCCE
        max-width: 100%
      @media screen and (max-width: 1023px)
        width: 100%
        font-weight: v-bind('components.searchBox.input.fontWeightMobile')

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus
  -webkit-transition-delay: 9999s !important
  transition-delay: 9999s !important
  color: v-bind('color') !important
  -webkit-text-fill-color: v-bind('color') !important
</style>
